import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested, isNotEmpty } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class PollDto {
  
    @ApiProperty()
    @IsOptional()
    Id:number;
    @ApiProperty()
    @IsNotEmpty()
    postId:number;
    @ApiProperty()
    @IsNotEmpty()
    userId:number;
    @ApiProperty()
    pollType:string;
    @ApiProperty()
    @IsNotEmpty()
    pollValue:string;
    @ApiProperty()
    status:boolean;
    createdAt: Date;
    @ApiProperty()
    createdUser: number | null;
    updatedAt: Date;
    @ApiProperty()
    updatedUser: number | null;
    @ApiProperty()
    versionFlag: number;
}

export class PollVotingDto {
  @ApiProperty()
  @IsOptional()
  Id:number;
  @ApiProperty()
  @IsNotEmpty()
  postId:number;
  @ApiProperty()
  @IsNotEmpty()
  userId:number;
  @ApiProperty()
  @IsNotEmpty()
  pollId:number;
  @ApiProperty()
  versionFlag: number;
}